import React, { use } from "react";
import styled from "styled-components";
import { Page ,FlexContainer} from "../../components/styled";
import BattleMoster from "../../assets/images/battleMoaster.png";
import CountdownBackground from "../../assets/images/countdownbackground.png";
import { useState,useEffect } from "react";
import ContinueButtonImage from "../../assets/images/continueButton.png";
import DeckCard from "../../components/shared/deckCard";
import Dark from "../../assets/images/types/dark.png";
import Grass from "../../assets/images/types/grass.png";
import { useCryptidSelectModal } from "../../hooks/useCryptidSelectModal";
import { useDeck } from "../../context/DeckContext";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../context/SocketContext";
import { BattleEvents } from "../../constants";
import {useToaster} from "../../hooks/useToaster"
import { useBattle } from "../../context/BattleContext";
import BeforeBattleMonsterBg from "../../assets/images/background/beforeBattleMonsterBg.png";

const BeforeBattle = () => {
    const [countdown, setCountdown] = useState(30);
    const [selectedCards, setSelectedCards] = useState([]);
    const [timedOut, setTimedOut] = useState(false);
    const {openCryptidSelectModal,closeCryptidSelectModal} = useCryptidSelectModal();
    const {userCards} = useDeck();
    const navigate = useNavigate();
    const {socket,isConnected} = useSocket();
    const {showToaster} = useToaster();
    const [useableCards, setUseableCards] = useState([]);
    const {isBattleStarted,setBattleResult,battleResult,battleData,season} = useBattle();
    useEffect(() => {
        if(battleResult){
            setBattleResult(null);
        }
        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    setTimedOut(true);
                    clearInterval(timer);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }
    , []);
    const openSelectCryptidModal = () => {
        
        openCryptidSelectModal(useableCards, onCardSelect,true, selectedCards, 4)
    }

    const onCardSelect = (cards) => {
        setSelectedCards(cards);
        console.log("Selected cards:", selectedCards);
        closeCryptidSelectModal();
    }
    const handleContinue = () => {
        if (selectedCards.length < 4) {
            alert("Please select 4 cards");
            return;
        }
        if (countdown === 0) {
            alert("Time is up");
            return;
        }
        if(socket){
            socket.emit(BattleEvents.CARDS_SELECTED,{cards:selectedCards})
            return
        }
        // navigate("/battle", { state: { selectedCards } });
    }
    const handleUseableCards = () => {
        const cards = userCards.filter((card) => {
            return season.availableRarities.includes(card.rarity._id)
        })
        setUseableCards(cards);
    }
    useEffect(() => {
        if (!userCards || !season) return; 
        handleUseableCards();
    }, [userCards,season])
    useEffect(()=>{
        if(!socket) return
        const handleSocketError = (error) => {
            showToaster({
                message:error.message,
                type:"error"
            })
            setTimeout(() => {
                socket.disconnect();
                navigate("/pvp");
            }
            , 2000);
    
        }
        socket.once(BattleEvents.ERROR,handleSocketError)
       return (() => {
            socket.off(BattleEvents.ERROR,handleSocketError)
        }
        )
    },[])
    useEffect(()=>{
        if(isBattleStarted){
            navigate("/battle");
        }
    }, [isBattleStarted])
    useEffect(() => {
        if (socket) {
            socket.on(BattleEvents.OPPONENT_CARDS_SELECTED, (data) => {
                showToaster({
                    message: "Opponent selected their cards",
                    type: "info",
                });
            });
        }
        return () => {
            socket.off(BattleEvents.OPPONENT_CARDS_SELECTED);
        }
    },[socket])
    // useEffect(() => {
    //     if (timedOut) {
    //         alert("Time is up");
    //         navigate("/home");
    //     }
    // }, [timedOut, navigate]);
    return (
        <Page>
            <FlexContainer flexdirection="column" style={{alignItems:"center",justifyContent:"flex-start",height:"100%",paddingTop:"34px",position:"relative",overflowY:"auto",paddingBottom:"24px"}}>
            <CountdownContainer>
                <img alt="countdown" src={CountdownBackground} />
                <span>{countdown}</span>
            </CountdownContainer>
            <img src={BeforeBattleMonsterBg} alt="monster" style={{ width: "60%", height: "auto",maxWidth:"245px"}} />
            <img src={battleData?.monster?.imageUri} alt="monster" style={{ width: "70%", height: "auto",maxWidth:"285px",position:"absolute",top:"-10px"}} />
            <FlexContainer gap="8px" style={{width:"60%",paddingTop:"14px",paddingBottom:"14px"}}>
                <TypeCard>
                    TYPE
                    <img src={require(`../../assets/images/types/${battleData.monster?.cryptidType.toLowerCase()}.png`)} alt="type" style={{width:"20px",height:"20px",marginLeft:"8px"}} />
                </TypeCard>
                <TypeCard>
                    WEAKNESS
                    <img src={require(`../../assets/images/types/${battleData.monster?.weaknessType.toLowerCase()}.png`)} alt="weakness" style={{width:"20px",height:"20px",marginLeft:"8px"}} />
                </TypeCard>
            </FlexContainer>
            <FlexContainer flexdirection="column">
                <h3>Charachter Selection</h3>
            <GridContainer>
                {React.Children.toArray(
                    Array.from({ length: 4 }, (_, i) => (
                        <DeckCard
                            clickAction={() => openSelectCryptidModal()}
                            card={selectedCards[i] || {}}
                            isSelected={selectedCards[i] ? true : false}
                            // containerStyle={{width:"100%",height:"100%"}}
                            key={i}
                        />
                    ))
                )}
            </GridContainer>
            </FlexContainer>
            <img onClick={handleContinue} alt="continue" style={{cursor:"pointer"}} src={ContinueButtonImage} />
            </FlexContainer>           
        </Page>
    );
}
const CountdownContainer = styled(FlexContainer)`
    width: 44px;
    height: 44px;
    position: absolute;
    top: 0;
    right: 8px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        width: 100%;
        height: 100%;
    }
    span{
        position: absolute;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        text-shadow: 4px 4px 24px rgba(255, 255, 255, 0.34);
    }

`
const GridContainer = styled.div`
    width: 80%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap:8px;
    padding-bottom: 4px;
`
const TypeCard = styled.div`
    border: 1.27px solid rgba(235, 132, 255, 0.67);
    background: linear-gradient(180deg, rgba(157, 75, 168, 0.27) 0%, rgba(103, 49, 110, 0.27) 56.5%, rgba(250, 210, 255, 0.27) 100%);
    border-radius: 6px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
`
export default BeforeBattle;